export default __webpack_public_path__ + "static/media/wizard hat.23dbbb72.png";